import React from 'react'
import ReactPlayer from 'react-player'
import imagenBanner1 from '../img/bannerPrincipal.png'
import Contactos from './Contactos'
import { FaPhone, FaMailBulk } from 'react-icons/fa';

const TrabajaConNosotros = () => {
    return (
        <>
            <div className='div-banner-imagen'>
                <img src={imagenBanner1} alt='Banner-Scorts' className='img-banner-principal'></img>
            </div>
            <div className='div-container-menu-padre'>
                <h3 className='btn-close-modal' style={{ marginBottom: "2rem", fontFamily: "Newton Howard", color: "#6ADFFF" }}>Trabaja con nosotros</h3>
                <div className="row m-0">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-6 ">
                        <p>
                            Si eres una chica con disposición personal, mental y sexual puedes ofrecer compañía neta, ofrecer placer sexual, conocer hombres, compartir con ellos experiencias inolvidables
                            y únicas, estás a la altura de asistir a eventos personales, corporativos, eres una chica educada con metas y tienes claro tu cuidado personal, estas preparada para trabajar
                            con la mejor agencia escort de Bogotá, “Infernal Paradise” busca contar con tus cualidades para ofrecer el mejor catalogo que nosotros como agencia de publicidad requerimos;
                        </p>
                        <br />
                        <p>
                            También si eres una mujer sin tabús, inteligente y con mucho deseo sexual podemos ofrecerte un acompañamiento para que al publicitarte en nuestra agencia puedas aprovechar tus
                            dotes al máximo para multiplicar tus ganancias y también encontrar clientes de alto nivel, también puedes tener en cuenta que eres clienta de infernal paradise al
                            momento que nos contratas para publicitarte
                        </p>
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-6 ">
                        <ReactPlayer url='https://appdgcbucketip.s3.amazonaws.com/videos/Video1.mp4' controls loop width='100%' />
                    </div>
                </div>
                <div className="row mt-5">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-6 ">
                        <div className='div-contactanos' >
                            <h3 className='btn-close-modal' style={{ fontFamily: "Newton Howard", color: "#fff", fontSize: "22px", marginRight: "2rem" }}>Contáctanos:</h3>
                            <div className='div-contactanos-links' >
                                <a href={`tel:+57313 3517257`} rel="noreferrer" className='div-contactanos-num'>
                                    <FaPhone className='faphone-icon-ccontact' />
                                    +57 313 351 72 57
                                </a>
                                <div>
                                    <FaMailBulk className='faphone-icon-ccontact' />
                                    contactanos@infernalparadise.com
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-6 ">
                        <Contactos />
                    </div>
                </div>
            </div>
        </>
    )
}

export default TrabajaConNosotros